import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy } from '@angular/core';
import { BoModel, BoGroupProp, BoProp, listTemplate } from '../../../models';
import { CoreService, HttpService } from '../../../services';
import { BoAdminBaseComponent } from '../boadmin-base.component';
import { DragModalOption, DragModalService } from '../../../modal-draggable';
import { PropBoOption } from '../propdata';
import * as _template from '../../template/index';
import { CdkDragDrop, CdkDragStart, CdkDragEnd, moveItemInArray, transferArrayItem, CdkDrag, CdkDropList, CdkDragEnter, } from '@angular/cdk/drag-drop';
import { BreakpointObserver } from '@angular/cdk/layout';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'q-adminbodata',
  templateUrl: './admin.bodata.component.html',
  styleUrls: ['./admin.bodata.component.css']
})

export class AdminBoDataComponent extends BoAdminBaseComponent implements OnInit, OnDestroy {

  private adminOld: boolean = false;
  propDragOptions: DragModalOption = new DragModalOption();
  propDragModalId: string = 'boPropAdmin' + crypto.randomUUID() + '_';
  dragContentShow: boolean = false; /* show drag-modal content only when property-data are loaded in order to avoid loop of calls */
  propOption: PropBoOption | null = null;
  NomColMaxLength: number = 4; // used in html
  BoModel: BoModel = new BoModel();
  IdBO: string = '0';
  showDdlBo: boolean = true;
  template: any;
  listTemplate: Array<listTemplate> = new Array<listTemplate>();
  recherche: string = '';

  public connectedTo: string[] = [];
  public lstRows: number[][];
  public rowsConnectedTo: string[] = [];
  public breakpoint: string = '(max-width: 768px)';
  @Input('IdentBO') set IdentBO(value: string) {
    this.IdBO = value ? value : '0';
    this.showDdlBo = value !== '0' ? false : true;
    this.initData();
  }

  @ViewChild('ModalCreateColumn', { static: false }) ModalCreateColumn: ElementRef;

  destroy$ = new Subject<void>();
  constructor(
    private data: HttpService,
    protected indParam: CoreService,
    private dragModservice: DragModalService,
    private breakpointObserver: BreakpointObserver
  ) {
    super();
    breakpointObserver
      .observe(this.breakpoint)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.CalculRows();
      });
  }


  ngOnInit(): void {
    this.propDragOptions.title = 'Administration Propriété BO';
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  GetDdl(IdentBo: string): void {
    this.IdBO = IdentBo;
    this.initData();
  }

  GetDdlColType(colType: string): void {
    this.BoModel.ColumnType = colType;
  }

  // Ouverture de la page de configuration d'une propriété
  Openconfig(prop: BoProp): void {
    const props: Array<any> = this.BoModel.DtProp.filter(p => p.Ident == prop.PropId);
    let columnSelect: string = '';
    if (prop.PropType.toUpperCase() === 'COMBO') {
      if ((props.length > 0 && props[0].TycolBOP === 'INT') || prop.PropColType === 'INT') {
        columnSelect = 'VaintBOV'
      }
      else {
        columnSelect = 'VastrBOV'
      }
    }

    if (this.adminOld) {
      const dest: string = `${this.BoModel.path}Param/PageNewParam.aspx?P1=${prop.PropId}&P2=${columnSelect}`;
      window.open(dest, '_blank');
    } else {
      this.propOption = new PropBoOption(this.IdBO, this.BoModel, prop.PropId, prop.PropCode, prop.PropName, columnSelect);
      this.dragModservice.open(this.propDragModalId);
      this.dragContentShow = true;
    }
  }

  SavePosition(): void {
    this.indParam.showSplash(true);
    this.BoModel.ListProp.forEach((prop: BoGroupProp) => {
      prop.PropList.forEach((props: BoProp) => {
        this.BoModel.ListPropFinal.push(props.PropId);
      });
    });
    this.BoModel.Mode = 'update';
    this.result = this.data.postHttp<BoModel>(`${this.indParam.AppParams.apiUrl}api/BoCtrl/`, this.BoModel).subscribe((result: BoModel) => {
      if (!result.HasError) {
        this.initData();
        this.indParam.showSplash(false);
      }
    });
  }

  AddConteneur(): void {
    const BoGroup: BoGroupProp = new BoGroupProp();
    BoGroup.PropList = new Array<BoProp>();
    this.BoModel.ListProp.push(BoGroup);
  }

  CreatColumn(): void {
    this.ModalCreateColumn.nativeElement.style.display = 'block';
  }

  // Creation d'une nouvelle colonne dans la base
  AddColumn(): void {
    this.BoModel.Mode = 'CreateColumn';
    if (isNaN(Number(this.BoModel.ColumnName.charAt(0)))) {
      if (!this.BoModel.ColumnName || !this.BoModel.ColumnInfo || !this.BoModel.ColumnType) { } else {
        this.indParam.showSplash(true);

        this.result = this.data.postHttp<BoModel>(`${this.indParam.AppParams.apiUrl}api/BoCtrl/`, this.BoModel).subscribe((result: BoModel) => {
          if (!result.HasError) {
            alert(`MAJ paramètre effectuée vous devez IMPERATIVEMENT relancer l'application pour la prise en compte des modifications`);
            this.initData();
            this.ModalCreateColumn.nativeElement.style.display = 'none';
            this.indParam.showSplash(false);
          }
        });
      }
    } else { alert('Attention le Code colonne ne peut pas commencer par un chiffre'); }
  }

  public highlightedProp(text: string): boolean {
    return this.recherche.trim() != '' && text.toLowerCase().includes(this.recherche.toLowerCase());
  }

  public drop(event: CdkDragDrop<any[]>) {
   
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }
  public DropGroup(event: CdkDragDrop<number[]>) {
    if (event.previousContainer === event.container ||  event.item.data >= event.container.data[0] + event.currentIndex) {
      moveItemInArray(this.BoModel.ListProp, event.item.data, event.container.data[0] + event.currentIndex);
    } else {
      moveItemInArray(this.BoModel.ListProp, event.item.data, event.container.data[0] + event.currentIndex - 1);
    }
   
    this.CalculRows();
  }
  public GetPropListToConnect(addListColumnNotUsed: boolean): BoProp[][] {
    let result: BoProp[][] = [];
    if (this.BoModel?.ListProp) {
      result = this.BoModel.ListProp.map(props => props.PropList);
    }
    if (addListColumnNotUsed)
      result.push(this.BoModel.ListColumnNotUsed);
    return result;
  }

  private initData(): void {
    this.BoModel.ListPropFinal = [];
    this.BoModel.ListPropInitial = [];

    this.indParam.showSplash(true);

    this.result = this.data.getHttp<BoModel>(`${this.indParam.AppParams.apiUrl}api/BoCtrl/getData/BOPROP/${this.IdBO}`).subscribe((result: BoModel) => {
      if (!result.HasError) {
        this.BoModel = result;
        this.connectedTo = Array.from(new Array(result?.ListProp?.length ?? 0), (x, i) => {
          const id = 'propList-' + i;
          i + 1;
          return id;
        });
        this.connectedTo.push('propList-unbinded')
        this.CalculRows();
        this.template = _template;
        //recuperation des infos des templates
        if (this.listTemplate.length == 0) {
          Object.keys(_template).forEach((t: any) => {
            if (this.template[t].prototype.__TemplateInfo) {
              let info = this.template[t].prototype.__TemplateInfo()
              if (info.table.includes(this.BoModel.TableName) || info.table.includes('ALL')) {
                this.listTemplate.push(new listTemplate(info.name, info.toolTips, info.table, this.template[t].name))
              }
            }
          })
        }


        const idBO: number = parseInt(this.IdBO);
        //const propBo: any = _l.find(result.ListBo, { 'Ident': idBO });
        //this.BoModel.StrBo = propBo ? propBo.Code_BOL : '';
        const propBo: any[] = result.ListBo.filter((e: any) => e.Ident === idBO);
        if (propBo && propBo.length > 0) {
          this.BoModel.StrBo = propBo ? propBo[0].Code_BOL : '';
          this.BoModel.ListPropInitial = [];
          this.BoModel.ListPropFinal = [];

          if (this.BoModel.ListProp) {
            this.BoModel.ListProp.forEach((prop: BoGroupProp) => {
              prop.PropList.forEach((props: BoProp) => {
                this.BoModel.ListPropInitial.push(props.PropId);
              });
            });
          }

          if (this.BoModel.IsSuperUser) {
            this.NomColMaxLength = 5;
          }

        }
        this.indParam.showSplash(false);
      }
    });
  }

  private CalculRows() {
    if (!this.BoModel?.ListProp) {
      this.lstRows = [];
    } else {
      let columnSize: number;
      if (this.breakpointObserver.isMatched(this.breakpoint)) {
        columnSize = 1;
      } else {
        columnSize = 3;
      }
      this.lstRows = this.BoModel?.ListProp
        .filter((_, outerIndex) => outerIndex % columnSize == 0) // create outter list of rows
        .map((
          _,
          rowIndex // fill each row from...
        ) => {
          this.rowsConnectedTo.push('groupList-' + rowIndex);
          return this.BoModel.ListProp.slice(
            rowIndex * columnSize, // ... row start and
            rowIndex * columnSize + columnSize // ...row end
          ).map((_, itemIndex) => rowIndex * columnSize + itemIndex)
        });
    }
  }
}
